import React from "react";
import { Link } from "react-router-dom";
import { Shell } from "@/components/Shell";

export default function RefundPolicy() {
    return (
        <Shell>
            <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
                <div className="label-base">Legal</div>
                <h1 className="font-heading text-4xl md:text-5xl font-extrabold tracking-tight mt-2">Refund policy</h1>
                <p className="mt-4 text-brand-mute text-lg">
                    HealthFairX charges vendors a small booth fee. We've designed our refund policy to balance vendor flexibility with host stability — hosts need confidence that their roster won't evaporate the week of the event.
                </p>

                <h2 className="font-heading text-2xl font-bold mt-12">Vendor-initiated cancellations</h2>
                <div className="mt-4 space-y-3">
                    <div className="rounded-xl border border-brand-line bg-white p-5" data-testid="policy-band-full">
                        <div className="font-heading font-bold text-brand-forest text-xl">Full refund</div>
                        <p className="text-sm text-brand-mute mt-1">Cancel <strong>4 weeks or more</strong> before the event date. You'll get 100% of your booth fee back automatically through Stripe.</p>
                    </div>
                    <div className="rounded-xl border border-brand-line bg-white p-5" data-testid="policy-band-partial">
                        <div className="font-heading font-bold text-amber-600 text-xl">50% refund</div>
                        <p className="text-sm text-brand-mute mt-1">Cancel <strong>between 2 and 4 weeks</strong> before the event date. Partial refunds are reviewed by a HealthFairX admin within one business day and then issued via Stripe.</p>
                    </div>
                    <div className="rounded-xl border border-brand-line bg-white p-5" data-testid="policy-band-none">
                        <div className="font-heading font-bold text-brand-coral text-xl">No refund</div>
                        <p className="text-sm text-brand-mute mt-1">Cancellations <strong>within 2 weeks</strong> of the event are not refundable. By this point the host has already planned around your presence.</p>
                    </div>
                </div>

                <h2 className="font-heading text-2xl font-bold mt-12" data-testid="refund-policy-host-section">Host-initiated changes</h2>
                <ul className="mt-4 space-y-3 text-brand-ink/85">
                    <li><strong>If the host cancels the event</strong>, every paid vendor receives a 100% refund — regardless of how close to the date the cancellation happens.</li>
                    <li><strong>If the host reschedules the event</strong>, your booth automatically moves to the new date. If the new date doesn't work for you, you can cancel for a full refund regardless of the timing relative to the original or new date.</li>
                </ul>

                <h2 className="font-heading text-2xl font-bold mt-12">How refunds are processed</h2>
                <p className="mt-4 text-brand-ink/85">
                    Refunds are issued back to the original payment method through Stripe. Most refunds land in your account within 5–10 business days depending on your bank. You'll receive an email confirmation from HealthFairX the moment the refund is issued.
                </p>

                <h2 className="font-heading text-2xl font-bold mt-12">Questions or disputes</h2>
                <p className="mt-4 text-brand-ink/85">
                    If you believe a refund decision was incorrect, email <a className="text-brand-forest font-semibold hover:underline" href="mailto:support@healthfairx.com">support@healthfairx.com</a> with your event name and booth confirmation. Our team reviews disputes within one business day.
                </p>

                <div className="mt-16 pt-8 border-t border-brand-line text-sm text-brand-mute">
                    <Link to="/" className="hover:text-brand-forest">← Back to homepage</Link>
                </div>
            </div>
        </Shell>
    );
}
